import React, { useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Bluebird from 'bluebird';
import { Breadcrumbs, Paper, Typography, Grid } from '@mui/material';
import { Home as HomeIcon } from '@mui/icons-material';
import routes from '../routes';
import * as donorsActions from '../actions/donors';
import * as foodDonorsActions from '../actions/foodDonors';
import OverlayLoader from '../components/OverlayLoader';
import FoodDonorAddForm from '../components/FoodDonorAddForm';
import NotificationsContext from '../context/NotificationsContext/NotificationsContext';
import * as notificationsHelper from '../helpers/notifications';
import { fetchUmbrellaFoodDonorsIfNeeded } from '../actions/umbrellaFoodDonors';
import {
  StyledRescuerBreadcrumb,
  StyledRescuerTextBreadcrumb,
} from '../pages/rescuerDashboard/rescuerDashboardMobile/Components/StyledRescuerBreadcrumb';
import snackbarHelper from '../helpers/snackbarHelper';

const FoodDonorAddView = ({ isMobileView, history }) => {
  const dispatch = useDispatch();
  const notificationsContext = useContext(NotificationsContext);
  const site = useSelector(state => state.app.site);
  const donorTypes = useSelector(state => state.entities.donors.types);
  const donorTypesList = donorTypes.allIds.map(donorTypeId => donorTypes.byId[donorTypeId]);
  const umbrellaFoodDonorsEntities = useSelector(state => state.entities.umbrellaFoodDonors);
  const umbrellaFoodDonorsList = Object.values(umbrellaFoodDonorsEntities.byId);
  useEffect(() => {
    dispatch(donorsActions.fetchDonorTypes());
    dispatch(fetchUmbrellaFoodDonorsIfNeeded());
  }, []);

  const onCreateFoodDonor = data => Bluebird
    .try(() => dispatch(foodDonorsActions.createFoodDonor({
      ...data,
      site_id: site.id,
    })))
    .then(() => {
      if (isMobileView) {
        snackbarHelper.success('Food Donor added successfully!');
        return history.push(routes.index);
      }

      notificationsHelper.addNotification('Food Donor added successfully!', notificationsContext);
      return history.push(routes.foodDonors);
    });

  return (
    <>
      {isMobileView ? (
        <Breadcrumbs aria-label="Breadcrumbs">
          <StyledRescuerBreadcrumb
            component={Link}
            to={routes.index}
            label="Home"
            icon={<HomeIcon style={{ color: '#fff' }} fontSize="small" />}
          />
          <StyledRescuerTextBreadcrumb component="a" href="#" label="Add a Food Donor" />
        </Breadcrumbs>
      ) : (
        <Breadcrumbs aria-label="Breadcrumbs">
          <Link color="inherit" to={routes.foodDonors}>
            Food Donors
          </Link>

          <Typography color="textPrimary">Add a Food Donor</Typography>
        </Breadcrumbs>
      )}

      <OverlayLoader isLoading={donorTypes.inflight || umbrellaFoodDonorsEntities.inflight}>
        <Paper
          sx={{
            padding: { xs: 1, sm: 2 },
            marginBottom: 3,
          }}
        >
          <Grid container>
            <Grid item xs={12} sm={8} md={6} lg={4}>
              <FoodDonorAddForm
                isMobileView={isMobileView}
                createFoodDonor={onCreateFoodDonor}
                donorTypes={donorTypesList}
                umbrellaFoodDonors={umbrellaFoodDonorsList}
              />
            </Grid>
          </Grid>
        </Paper>
      </OverlayLoader>
    </>
  );
};

export default FoodDonorAddView;
